import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Pricing from "./pages/Pricing";

// Check for token in URL BEFORE first render (Google OAuth redirect)
function getInitialAuth() {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  if (token) {
    localStorage.setItem("token", token);
    window.history.replaceState({}, document.title, "/dashboard");
    return true;
  }
  return !!localStorage.getItem("token");
}

export default function App() {
  const [auth, setAuth] = useState(getInitialAuth);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={!auth ? <Login setAuth={setAuth} /> : <Navigate to="/dashboard" />} 
        />
        <Route 
          path="/register" 
          element={!auth ? <Register setAuth={setAuth} /> : <Navigate to="/dashboard" />} 
        />
        
        {/* Private Routes */}
        <Route 
          path="/dashboard" 
          element={auth ? <Dashboard setAuth={setAuth} /> : <Navigate to="/login" />} 
        />
        <Route 
          path="/pricing" 
          element={auth ? <Pricing /> : <Navigate to="/login" />} 
        />

        {/* Default Route */}
        <Route path="*" element={<Navigate to={auth ? "/dashboard" : "/login"} />} />
      </Routes>
    </Router>
  );
}
